import Vue from 'vue';
import store from '@/plugins/vuex/';
import ActionButton from '@/components/action_button/Index.vue';
import { DIY } from '@/helpers/constants/Store';
import { createNamespacedHelpers } from 'vuex';
import '@/assets/stylesheets/v2/_success-launch.scss';
import BaseText from '@/components/BaseText.vue';
import LaunchMiniApp from '@/plugins/graphql/mutations/v2/launch-mini-app.gql';
import LaunchStore from '@/plugins/graphql/mutations/v2/store_manager/store-launch.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import AppBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import appBasicFragment from '@/plugins/graphql/fragments/v2/app-basic.gql';
import '@/assets/stylesheets/utils/global-modifiers.scss';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import UserPilotMixin from '@/helpers/vue_mixins/v2/UserpilotMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
const { mapGetters, mapMutations } = createNamespacedHelpers(DIY);
export default Vue.extend({
    mixins: [AlertMixin, SegmentAnalyticsMixin, UserPilotMixin, CleverTapEventsMixin],
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        store: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            agreeToTerms: false,
            onLaunch: false,
        };
    },
    computed: {
        ...mapGetters(['togglePreLaunch']),
        imageUrl() {
            return require('@/assets/images/launch.svg');
        },
        launchMutation() {
            if (this.store) {
                this.userpilotTrack('Launched Store');
                return LaunchStore;
            }
            this.userpilotTrack('Launched Mini App');
            return LaunchMiniApp;
        },
    },
    methods: {
        ...mapMutations(['hidePreLaunch']),
        ...mapMutations(['show']),
        launchApp() {
            const self = this;
            self.onLaunch = true;
            self.$apollo
                .mutate({
                mutation: self.launchMutation,
                variables: {
                    input: self.launchInput(),
                },
                update(cache, { data }) {
                    const { app } = data.launchApp || data.appStoreLaunch;
                    const { uuid, name, launchedAt, activePage, storeStatus } = app;
                    cache.writeFragment({
                        id: uuid,
                        fragment: appBasicFragment,
                        data: {
                            /* eslint no-underscore-dangle: 0 */
                            __typename: app.__typename,
                            uuid,
                            name,
                            launchedAt,
                            storeStatus,
                            activePage,
                        },
                        fragmentName: 'AppBasic',
                    });
                    self.onAppLaunch();
                    this.segmentTrack('DIY Launch Mini App', {
                        uuid,
                        name,
                        launchedAt,
                        activePage,
                        storeStatus,
                    });
                },
                refetchQueries: [
                    {
                        query: AppBasic,
                        variables: {
                            appUuid: this.appUuid,
                        },
                    },
                ],
            })
                .then(() => {
                // Remove this due to implementation of launched success page
                // self.show();
                store.commit('setTodoSuccessMessage', "Your journey in In-App Commerce begins now. Let's take your store to the next level:");
                this.clearPersistentErrorNotification();
                this.$router.push({ name: 'mini-app-launched-success' });
            })
                .catch((e) => {
                self.errorNotification(e.message);
            })
                .finally(() => {
                self.onLaunch = !this.onLaunch;
                self.hidePreLaunch();
                self.$emit('onClose');
            });
        },
        ...mapMutations(['showTerms']),
        gotToTerms() {
            const { origin } = window.location;
            window.open(`${origin}/terms`);
        },
        launchInput() {
            const input = {
                appUuid: this.appUuid,
            };
            if (!this.store) {
                Object.assign(input, {
                    pageUrl: this.$router.currentRoute.path,
                    userAgent: navigator.userAgent,
                });
            }
            return input;
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-dialog', {
            props: {
                persistent: true,
                value: self.togglePreLaunch,
                contentClass: 'success-launch -pre-launch',
            },
        }, [
            createElement('v-card', { class: 'card pa-4' }, [
                createElement('v-layout', { class: 'column align-center justify-center fill-height' }, [
                    createElement('v-flex', { class: 'shrink text-xs-right', style: 'width: 100%; ' }, [
                        createElement('v-btn', {
                            props: {
                                flat: true,
                                icon: true,
                                color: 'grey',
                            },
                            on: {
                                click: () => {
                                    self.hidePreLaunch();
                                },
                            },
                            class: '',
                            attrs: {
                                // eslint-disable-next-line
                                ['data-cy']: 'agree-to-terms-close-icon',
                            },
                        }, [
                            createElement('v-icon', {
                                on: {
                                    click: () => {
                                        store.commit('toggleReadySuccessMessage', false);
                                    },
                                },
                            }, ['close']),
                        ]),
                    ]),
                    createElement('v-flex', { class: 'mb-4' }, [
                        createElement('v-img', {
                            props: {
                                src: this.imageUrl,
                                height: '180px',
                                width: '280px',
                            },
                        }),
                    ]),
                    createElement('v-flex', [
                        createElement('p', { class: 'header' }, ['Launch In-App Store']),
                        createElement('p', { class: 'body' }, [
                            'You are now ready to sell inside the world’s biggest apps.',
                        ]),
                    ]),
                    createElement('v-flex', [
                        createElement('v-layout', { class: 'align-center' }, [
                            createElement('v-flex', { class: 'mt-1' }, [
                                createElement('v-checkbox', {
                                    class: 'caption',
                                    props: {
                                        label: `I agree to `,
                                        class: 'caption',
                                    },
                                    on: {
                                        change: (val) => {
                                            self.agreeToTerms = val;
                                        },
                                    },
                                    attrs: {
                                        // eslint-disable-next-line
                                        ['data-cy']: 'agree-to-terms-checkbox',
                                    },
                                }),
                            ]),
                            createElement('v-flex', {
                                on: {
                                    click: () => {
                                        self.gotToTerms();
                                    },
                                },
                                class: 'mt-3 ml-1 cursor -pointer ',
                            }, [
                                createElement(BaseText, {
                                    props: {
                                        slot: 'label',
                                        text: 'Terms of Use and Privacy Policy',
                                        textBlue: true,
                                        regular: true,
                                        footer: true,
                                        class: 'mb-1 term',
                                    },
                                }),
                            ]),
                        ]),
                    ]),
                    createElement('v-flex', { class: 'shrink' }, [
                        createElement(ActionButton, {
                            props: {
                                orangeTheme: true,
                                disable: !self.agreeToTerms,
                                submit: true,
                                requestOnProcess: self.onLaunch,
                            },
                            on: {
                                wasClicked: self.launchApp,
                            },
                            class: 'launch-btn',
                            attrs: {
                                // eslint-disable-next-line
                                ['data-cy']: 'agree-to-terms-launch-button',
                            },
                        }, ['Launch']),
                    ]),
                ]),
            ]),
        ]);
    },
});
